module.exports =
{
    theme: 'dark', // 'dark', 'light'
    // Meta Tags für Facebook, Twitter
    meta: {
        // Seiten Title
        title: 'Die Internationale Raumstation ISS in 3D ',
        // Beschreibung
        description: 'Sechs Monate forschte Astronaut Matthias Maurer auf der Internationalen Raumstation ISS. Drehen und wenden Sie nun selbst das Megalabor - 400 Kilometer über uns im Weltraum.',
        // Bild
        image: 'https://3d.zdf.de/iss/img/Linkpreview.jpg',
        // URL
        url: 'https://3d.zdf.de/iss/',
    },
    tracking: {
        storyName: 'ISS_Cosmic_Kiss',
        storyID: '3D ISS',
        // // Tracking deaktivieren
        // disabled: false,
    },
    babylon: {

        lightIntensity : 0,

        camera: {
            // Position, Ausrichtung und Kamera Bewegung
            // Kamera Position
            position: [0,.2,100], // alpha, beta, radius
            moveFunction: 'move', // Wie die Kamera bewegt wird: 'move' Kamerafahrt, 'set' Springt zur Position
            target: [10,0,0], // Wohin die Kamera blickt
            animationSpeed: 280, // Geschwindigkeit der Kamerabewegung

            // Begrenzungen
            alphaLimits: [null, null],
            betaLimits: [0.1, Math.PI],  //[0.1, Math.PI / 2],
            radiusLimits: [6, 200], // minCamRadius, maxCamRadius   war 4 oder 5
            clipping: [.2, 10000.0],
            fov: 0.8,

            // Automatisches Drehen
            useAutoRotationBehavior: false,
            idleRotationSpeed: 0.05,

            // Steuerung
            panSensibility: 0, // 0 is deactivated
            wheelPrecision: 25.0, // 3.0 ist Standard
        },
    },
    audio: {
        enabled: true
    },
    objects:
    [
        // {
        //     // Name des Objekts zur Ansteuerung
        //     name: "zdfLogo",
        //     // GLB Dateiname im Ordner app/public/3d-models
        //     filename: "ZDF_Logo.glb",
        //     options: {
        //         //// BaseObject
        //         // true: Objekt anzeigen
        //         visible: true,
        //         // Rotation
        //         rotation: [0.5 * Math.PI, 0, 0],
        //         // Rotation Quaternion, siehe https://doc.babylonjs.com/features/position,_rotation,_scaling#rotationquaternion
        //         //rotationQuaternion: 
        //         // Skalierung: Objekt Größe ändern in allen Dimensionen
        //         scaling: [1, 1, -1],
        //         // Skalierung: Objekt Größe ändern (Alle Dimensionen gleich)
        //         //scale: 0.01,
        //         // Position
        //         position: [0, 0, 0],[0.707, 0, 0, 0.707],
        //         // Transparenz (0 bis 1)
        //         //visibility: 0.25,
        //         // RGB-Farbe (diffuse) jeweils Werte 0 bis 255
        //         //diffuse: [255, 0, 0],
        //         // Zur Kamera ausrichten
        //         // 1: X-Achse, 2: Y-Achse, 4: Z-Achse, 7: Alle Achsen
        //         // 3: X & Y-Achse, 5: Z & X-Achse, 6: Z & Y-Achse
        //         // https://doc.babylonjs.com/typedoc/classes/babylon.abstractmesh#billboardmode
        //         billboardMode: 0,
        //         // Overlay Color zum hervorheben von Objekten
        //         //overlayColor: [250/255, 125/255, 25/255],
        //         // Rendering Group ID legt Objekte eine ebene nach vorne (Auch beim Hotspot)
        //         //renderingGroupId: 1

        //         //// MeshObject
        //         // Objekt mit Fade ein und ausblenden, wenn visible sich ändert
        //         fade: false,
        //         // Unter-Mesh-Objekte in der Datei
        //         // Name des Meshs wie im 3D Model
        //         ZDF_Logo: {
        //             visible: true,
        //             fade: false,
        //             // Ist das Objekt anklickbar?
        //             // Bei true wird ein Hotspot durch das Objekt nicht anklickbar, wenn verdeckt.
        //             // Darum sollte bei transparenten Objekten ggf. pickable: false gesetzt werden.
        //             pickable: true,

        //             ZDF_Logo_2: {
        //                 visible: true,
        //                 fade: false,
        //             }
        //         },

        //         //// BabylonObject
        //         // animation=true: startet die Animation im Objekt
        //         animation: false

        //         // Nur initial, nicht per babylonState
        //         // OnClick Trigger
        //         // trigger: function () { }
        //     },
        //     // Callback wenn Objekt geladen und erstellt wurde zum setzen weiterer Einstellungen.
        //     callback: function (zdfLogo) // eslint-disable-line no-unused-vars
        //     {

        //     }
        // },
        // Dies koennte ein zweites Objekt sein, das ihr ladet.
        {
            name: "iss",
            filename: "iss.glb",
            options: {
                visible: true,
                position: [0, 0, 0],
                scaling: [1, 1, -1],
                rotation: [0, 0, 0],
                fade: true,

                children:{

                        Astro_plane: {
                            fade: true,
                            visible: false,
                            position: [-1.1,1.87,1],
                            rotation: [0,0,0],
                            scale: [0.12],
                            billboardMode: 7,
                        },

                    Umlaufbahn: {
                        visible: false
                    },
                    

                    Label_BG_28k: {
                        billboardMode: 7,
                        //fade: true,
                        visible: false,
                        Typo_28k: {
                            fade: true,
                            visible: false
                        },
                    },

                    Label_BG_109m: {
                        //fade: true,
                        visible: false,
                        Typo_109m: {
                            visible: false
                        }

                    },
                    Pfeil_109m: {
                        //fade: true,
                        visible: false,
                    },


                    Label_BG_73m: {
                        //fade: true,
                        visible: false,
                        Typo_73m: {
                            fade: true,
                            visible: false
                        }

                    },
                    Pfeil_73m: {
                        //fade: true,
                        visible: false,
                    },



                    Flagge_Russland: {
                        //fade: true,
                        visible: false,
                        // position: [.5, .4, -6],

                    },

                    Flagge_USA: {
                        //fade: true,
                        visible: false,
                        // position: [-2, 1, 2],

                    },


                    Flagge_USA_back: {
                        //fade: true,
                        visible: false,
                        // position: [-2, 1, 2],

                    },

                    Flagge_EU: {
                        //fade: true,
                        visible: false,
                        // position: [2, -1, 5],

                    },

                    Flagge_Japan: {
                        //fade: true,
                        visible: false,
                        // position: [-2, -1, 6],

                    },

                    Flagge_Kanada: {
                        //fade: true,
                        visible: false,
                        // position: [3.5, 2, 3],

                    },

                    sonne: {
                        billboardMode: 7,
                    },

                    erde_pivot: {
                        erde: {
                            //visibility: 0.2,
                            fade: true,
                            visible: false
                        }
                    },
                        
                    Soyuz_remodel: {
                        visible: false,
                        Panels_Soyuz: {
                                visible: false
                            }
                    },

                    kontur_flugzeug: {
                        visible: false
                    },

                    kontur_flugzeug_seite: {
                        visible: false
                    },

                    kontur_fussballfeld: {
                        visible: false,
                    },

                    kontur_auto: {
                        visible: false,
                    },

                    kontur_astronaut: {
                        visible: false,
                    },

                    Columbus: {
                        //position: [0,0,0],
                        Columbus_Aussenkonstruktion: {
                        //scaling: [2,2,2],
                        overlayColor: [50/255, 25/255, 120/255],
                        //position: [0,-1,0]
                        },
                    },

                    SpaceX_Body: {
                        visible: false
                    },
                }
            },

            callback: function (iss) // eslint-disable-line no-unused-vars
            {

                let MAT_FlugzeugSeite = this.scene.getNodeByName('kontur_flugzeug_seite').material;
                MAT_FlugzeugSeite.disableLighting = true;

                let MAT_FlugzeugOben = this.scene.getNodeByName('kontur_flugzeug').material;
                MAT_FlugzeugOben.disableLighting = true;

                let MAT_Auto = this.scene.getNodeByName('kontur_auto').material;
                MAT_Auto.disableLighting = true;

                let MAT_Typo_weiss = this.scene.getNodeByName('Typo_73m').material;
                MAT_Typo_weiss.disableLighting = true;

                let MAT_Pfeil = this.scene.getNodeByName('Pfeil_109m').material;
                MAT_Pfeil.disableLighting = true;

                let MAT_Sonne = this.scene.getNodeByName('sonne').material;
                MAT_Sonne.disableLighting = true;

                let MAT_Japan = this.scene.getNodeByName('Flagge_Japan').material;
                MAT_Japan.disableLighting = true;

                let MAT_EU = this.scene.getNodeByName('Flagge_EU').material;
                MAT_EU.disableLighting = true;

                let MAT_USA = this.scene.getNodeByName('Flagge_USA').material;
                MAT_USA.disableLighting = true;

                let MAT_Russland = this.scene.getNodeByName('Flagge_Russland').material;
                MAT_Russland.disableLighting = true;

                let MAT_Kanada = this.scene.getNodeByName('Flagge_Kanada').material;
                MAT_Kanada.disableLighting = true;

                let MAT_Astro = this.scene.getNodeByName('Astro_plane').material;
                MAT_Astro.disableLighting = true;

            }
        }
    ]
};
